// extracted by mini-css-extract-plugin
module.exports = {"quotesTable":"_8ee58978","quotesTableHeaderCell":"_e97cf9e1","quotesTableBodyCell":"_adfc768e","priceData":"_4c1311b2"};